import React from 'react';
import { SkeletonLoading } from '@saleshandy/design-system';

const TBodyLoader: React.FC = () => (
  <div className="tanstack-table--tbody">
    {[1, 2, 3, 4, 5, 6].map((key) => (
      <div className="tanstack-table--tr" key={key}>
        {[150, 180, 120, 150, 180, 120].map((width) => (
          <div className="tanstack-table--td" key={width} style={{ flex: '1' }}>
            <div className="column-cell-content loading">
              <SkeletonLoading width={width} height={18} />
            </div>
          </div>
        ))}
      </div>
    ))}
  </div>
);

export default TBodyLoader;
